import React, { useContext } from 'react'
import './donate.css'
import { BiLogOut} from 'react-icons/bi'
import { DonateContext } from '../../context/donateContext'

const Donate = () => {
    const {isDonateOpen, setIsDonateOpen} = useContext(DonateContext);

    const CloseDonate = () =>{
        setIsDonateOpen(false)
    }

  return (

    <div className={`donate_container ${isDonateOpen === null ? '' : isDonateOpen ? 'opening' : 'close'}`}>
        <div className='donate_header'>
            <h1>EWCDC Banking Details</h1>
        </div>
        <div className='donate'>
            <h2>account name: <span className='span_title'>ewcdc</span></h2>
            <h2>account type: <span className='span_cheque'>cheque account</span></h2>
            <h2>bank name: <span className='span_bank'>standard bank</span></h2>
            <h2>account number: <span className='span_bank'>012698458</span></h2>
            <h2>address bank: <span className='span_bank'>po box 35432 menlo park 0102, pretoria, gauteng</span></h2>
            <h2>branch name: <span className='span_area'>menlyn pta</span></h2>
            <h2>branch code: <span className='span_bank'>012345(or universal branch code 051001)</span></h2>
            <h2>intern. Bank code: <span className='span_bank_code'>sbzazajj</span></h2>
            <h2>signatories: <ul className='donate_list'><li>Mr D.M Mahlangu (The CEO)</li>
            <li>Ms P.M Mabhena (Treasure)</li>
            <li>Ms S.M Mahlangu (Administrator)</li></ul></h2>
        </div>
        <BiLogOut className='closing_window' onClick={CloseDonate}/>
    </div>
  )
}

export default Donate